import { InstagramAnalyticsReelDetails } from '@anytag/graphql';
import { PostModal } from '../shared';

export interface ReelPostTemplateProps {
  className?: string;
  onCloseModal?: () => void;
  data?: InstagramAnalyticsReelDetails;
}

export const ReelPostTemplate = ({ data, className, onCloseModal }: ReelPostTemplateProps) => {
  if (!data) {
    onCloseModal?.();

    return null;
  }

  return (
    <PostModal.DetailsTemplate
      className={className}
      data={{
        isReel: true,
        caption: data.content,
        postDate: data.postDate,
        socialMedia: 'INSTAGRAM',
        postUrl: data.postUrl || '',
        comments: data.commentList || [],
        images: data.thumbnail ? [data.thumbnail] : [],
        info: {
          avatar: data.avatarUrl,
          followers: data.followers,
          name: data.instagramAccountName
        },
        statistics: {
          likes: data.analysis?.likes,
          comments: data.analysis?.comments,
          views: data.analysis?.views,
          saves: data.analysis?.saves,
          reach: data.analysis?.reach,
          shares: data.analysis?.shares
        }
      }}
    />
  );
};
